/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// Redux Toolkit
import { useDispatch, useSelector } from "react-redux";
// Base UI Components
import NavLinkAdapter from "../../../@BASE/core/NavLinkAdapter";
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
// Framer Motion
import { motion } from "framer-motion";
// Material-UI
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// actions
import { selectUser } from "../../store/userSlice";
// authRoles
import authRoles from "../../auth/authRoles";
// components
import DateGreeting from "../DateGreeting";

function DashboardHeader(props) {
  const user = useSelector(selectUser);

  return (
    <div 
      style={{
        // backgroundImage: `url(${backgroundURL})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div 
        className="p-24 sm:p-32 sm:py-120 w-full"
      >
        <div className="flex flex-col items-center sm:items-start">
          <DateGreeting />
          <Typography
            component={motion.span}
            initial={{ y: -20 }}
            animate={{ y: 0, transition: { delay: 0.2 } }}
            delay={300}
            className="text-20 md:text-40 font-extrabold tracking-tight leading-none"
          >
            Welcome back, {user.first_name} {user.last_name}!
          </Typography>
        </div>
        {/* <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center mt-24">
          {(authRoles.admin.includes(user.role)) && (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0, transition: { delay: 0.2 } }}
            >
              <Button
                className="ml-8"
                variant="contained"
                component={NavLinkAdapter}
                to="new/edit"
                sx={{
                  backgroundColor: 'common.white',
                  color: 'primary.dark',
                }}
              >
                <BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>
                <span className="mx-8">Add</span>
              </Button>
            </motion.div>
          )}
        </div> */}
      </div>
    </div>
  );
}

export default DashboardHeader;
